import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { BookOpen } from "lucide-react";

export function CleanerGuideGate() {
  const [gate, setGate] = useState(null);
  useEffect(() => { api.get("/training/cleaner-gate").then((r) => setGate(r.data)).catch(() => {}); }, []);
  if (!gate?.blocked) return null;
  return (
    <div className="rounded-2xl border border-amber-200 bg-amber-50 p-4 flex items-start gap-3" data-testid="cleaner-guide-gate">
      <BookOpen className="w-5 h-5 text-amber-700 mt-0.5 shrink-0" />
      <div className="text-sm text-amber-900">
        <div className="font-medium">Before your first turnover, read these guides and tap "Mark as read":</div>
        <ul className="mt-1 list-disc ml-5">
          {gate.missing.map((m) => (
            <li key={m.slug}><a href={`${process.env.REACT_APP_BACKEND_URL}/api/training/${m.slug}.pdf`} target="_blank" rel="noreferrer"
              className="underline hover:text-amber-700" data-testid={`cleaner-guide-gate-${m.slug}`}>{m.title}</a></li>
          ))}
        </ul>
        <Link to="/training-guides" className="inline-block mt-2 text-xs font-medium text-teal-800 hover:underline" data-testid="cleaner-guide-gate-open">Open Training guides →</Link>
      </div>
    </div>
  );
}

export function RequiredGuidesCard() {
  const [data, setData] = useState(null);
  const [sel, setSel] = useState([]);
  useEffect(() => { api.get("/training/cleaner-required").then((r) => { setData(r.data); setSel(r.data.slugs); }).catch(() => {}); }, []);
  if (!data) return null;
  const toggle = async (slug) => {
    const next = sel.includes(slug) ? sel.filter((s) => s !== slug) : [...sel, slug];
    setSel(next);
    await api.put("/training/cleaner-required", { slugs: next });
  };
  return (
    <div className="ns-card p-8 mt-6" data-testid="settings-cleaner-required-guides">
      <div className="font-serif text-2xl">Cleaner guide gating</div>
      <p className="text-sm text-slate-500 mt-1 mb-4">New cleaners (no completed turnover yet) must mark these guides as read before they can tap "I'm here" or start a turnover. Untick everything to switch gating off.</p>
      <div className="grid sm:grid-cols-2 gap-2">
        {data.options.map((o) => (
          <label key={o.slug} className="flex items-center gap-2 text-sm cursor-pointer rounded-lg border border-slate-100 px-3 py-2 hover:bg-slate-50 transition-colors">
            <input type="checkbox" checked={sel.includes(o.slug)} onChange={() => toggle(o.slug)} data-testid={`settings-required-guide-${o.slug}`} />
            {o.title}
          </label>
        ))}
      </div>
    </div>
  );
}
